module.exports = __webpack_public_path__ + "assets/66eae03dc2a439fd0e7b5b34765e0437.png";